import {createContext, PropsWithChildren, useContext} from 'react';

import {FilterDialogSection} from 'filters/features/FilterDialog/types';
import {PageFilter} from 'filters/types';

type FilterDialogState = {
  id?: string;
  title: string;
  sections: FilterDialogSection[];
  // Should return true if valid or string with error message
  validate?: (filter: PageFilter) => Promise<string | true> | string | true;
  // Should return true if valid or string with warning message
  warn?: (filter: PageFilter) => Promise<string | true> | string | true;
};

const FilterDialogContext = createContext<FilterDialogState>(null as never);

export const useFilterDialogContext = () => {
  const context = useContext(FilterDialogContext);

  if (!context) {
    throw new Error('useFilterDialogContext must be used within a FilterDialogProvider');
  }

  return context;
};

export const FilterDialogProvider = ({children, ...value}: PropsWithChildren<FilterDialogState>) => {
  return <FilterDialogContext.Provider value={value}>{children}</FilterDialogContext.Provider>;
};
